import type { BasicTableProps, TableActionType, FetchParams, BasicColumn } from '../types/table';
import { ref, onUnmounted, unref, watch, toRaw, WatchStopHandle } from 'vue';
import { getDynamicProps } from '@/utils/common';
import { DynamicProps } from 'types/config';
type tableProps = Partial<DynamicProps<BasicTableProps>>;
type UseTableMethod = TableActionType;
//返回WeTable组件的配置
export function useTable(
  tableProps?: tableProps
): [(instance: TableActionType, formInstance: TableActionType) => void, TableActionType] {
  const tableRef = ref<Nullable<TableActionType>>(null);
  const loadedRef = ref<Nullable<boolean>>(false);
  const formRef = ref<Nullable<UseTableMethod>>(null);

  let stopWatch: WatchStopHandle;
  //创建table实例
  function register(instance: TableActionType, formInstance: UseTableMethod) {
    onUnmounted(() => {
      tableRef.value = null;
      loadedRef.value = null;
      formRef.value = null;
    });
    if (unref(loadedRef) && instance === unref(tableRef)) return;

    tableRef.value = instance;
    tableProps && instance.setProps(getDynamicProps(tableProps));
    loadedRef.value = true;
    formRef.value = formInstance;
    stopWatch?.();

    stopWatch = watch(
      () => tableProps,
      () => {
        tableProps && instance.setProps(getDynamicProps(tableProps));
      },
      {
        immediate: true,
        deep: true,
      }
    );
  }
  function getTableInstance(): TableActionType {
    const table = unref(tableRef);
    return table as TableActionType;
  }
  const methods: TableActionType = {
    reload: async (opt?: FetchParams) => {
      getTableInstance() && getTableInstance().reload(opt);
    },
    setProps: (props: Partial<BasicTableProps>) => {
      getTableInstance().setProps(props);
    },
    getDataSource: () => {
      return toRaw(getTableInstance().getDataSource());
    },
    getTotalCount: () => {
      return getTableInstance().getTotalCount();
    },
    getColumns: ({ ignoreIndex = false }: { ignoreIndex?: boolean } = {}) => {
      const columns = getTableInstance().getColumns({ ignoreIndex }) || [];
      return toRaw(columns);
    },
    setColumns: (columns: BasicColumn[] | string[]) => {
      getTableInstance().setColumns(columns);
    },
    setTableData: (values: any[]) => {
      return getTableInstance().setTableData(values);
    },
    updateTableData: (index: number, key: string, value: any) => {
      return getTableInstance().updateTableData(index, key, value);
    },
    getSelectRowKeys: () => {
      return toRaw(getTableInstance().getSelectRowKeys());
    },
    getSelectRows: () => {
      return toRaw(getTableInstance().getSelectRows());
    },
    clearSelectedRowKeys: () => {
      getTableInstance().clearSelectedRowKeys();
    },
    getOptions: () => {
      return getTableInstance().getOptions();
    },
    fetchAllNoChange: (opt: any) => {
      return getTableInstance().fetchAllNoChange(opt);
    },
    getRowSpan: (key, text, index, id?) => {
      return getTableInstance().getRowSpan(key, text, index, id);
    },
    getFieldsValue: () => {
      return getTableInstance().getFieldsValue();
    },
    set_search_item_value: (prop, val) => {
      return getTableInstance().set_search_item_value(prop, val);
    },
    getViewColumns: () => {
      return getTableInstance().getViewColumns();
    },
  };
  return [register, methods];
}
